// Alpine.js component for campaign reports
export default function campaignReports() {
    return {
        reportScope: 'campaign',
        reports: [],
        loading: false,
        error: null,

        init() {
            console.log('✅ Campaign Reports Alpine component initialized');
        },

        async getReports() {
            this.loading = true;
            this.error = null;
            
            try {
                console.log(`📊 Fetching reports for scope: ${this.reportScope}`);
                
                const response = await axios.get(`/api/reports/campaigns/${this.reportScope}`);
                this.reports = response.data.map(report => {
                    report.identifier = report.extras ? report.extras[Object.keys(report.extras)[0]] : '';
                    return report;
                });
                
                console.log(`✅ Loaded ${this.reports.length} reports`);
            } catch (error) {
                console.error('❌ Error fetching reports:', error);
                this.error = 'Failed to load reports. Please try again.';
                this.reports = [];
            } finally {
                this.loading = false;
            }
        },

        scopeChanged() {
            this.reports = [];
            console.log(`🔄 Scope changed to: ${this.reportScope}`);
        },

        formatCurrency(value) {
            return parseFloat(value).toFixed(2);
        },

        calculateCPC(cost, conversions) {
            return conversions === 0 ? 0 : (cost / conversions);
        },

        getBadgeClass(report) {
            if (report.ruleHappened && report.impression === 'success') {
                return 'bg-success';
            } else if (!report.ruleHappened && report.impression === 'success') {
                return 'bg-danger';
            } else if (!report.ruleHappened && report.impression === 'error') {
                return 'bg-danger';
            } else if (report.ruleHappened && report.impression === 'error') {
                return 'bg-danger';
            }
            return 'bg-secondary';
        },

        getBadgeText(report) {
            if (report.ruleHappened && report.impression === 'success') {
                return 'PUSH';
            } else if (!report.ruleHappened && report.impression === 'success') {
                return 'Details';
            } else if (!report.ruleHappened && report.impression === 'error') {
                return 'Details';
            } else if (report.ruleHappened && report.impression === 'error') {
                return 'STOP';
            }
            return 'Unknown';
        }
    }
}